import { render, staticRenderFns } from "./hello-config.vue?vue&type=template&id=20adc806&"
import script from "./hello-config.vue?vue&type=script&lang=ts&"
export * from "./hello-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports